<template>
  <USlideover v-model="model">
    <UCard class="flex flex-col flex-1">
      <template #header>
        <div class="flex items-center justify-between">
          <div class="flex items-center gap-3">
            <UButton
              v-if="currentLevel > 0"
              @click="goBack"
              icon="i-heroicons-chevron-left"
              color="gray"
              variant="ghost"
              class="-ml-2"
            />
            <h3 class="text-base font-semibold leading-6 text-gray-900">
              {{ currentLevel > 0 ? currentCategory?.name : 'Kategoriler' }}
            </h3>
          </div>
          <UButton
            color="gray"
            variant="ghost"
            icon="i-heroicons-x-mark-20-solid"
            class="-my-1"
            @click="closeSlide"
          />
        </div>
      </template>

      <!-- Content -->
      <div class="relative w-full h-full">
        <TransitionGroup>
          <div
            v-for="(level, index) in nestedMenus"
            :key="index"
            class="absolute inset-0 transition-transform duration-300"
            :class="{
              'translate-x-full': index > currentLevel,
              'translate-x-0': index === currentLevel,
              '-translate-x-full': index < currentLevel
            }"
          >
            <ul class="p-2 space-y-2">
              <li
                v-for="item in level"
                :key="item.id"
                class="rounded-lg overflow-hidden bg-slate-50 hover:bg-slate-100 transition-colors"
              >
                <div class="flex items-center">
                  <NuxtLink
                    :to="`/${item.slug}-a${item.id}`"
                    class="flex items-center gap-3 flex-1 p-3"
                    @click="closeSlide"
                  >
                    <div
                      class="w-12 h-12 rounded-lg overflow-hidden bg-white border border-slate-200"
                    >
                      <NuxtImg
                        :src="'cl/' + item.icon"
                        class="w-full h-full object-cover"
                        loading="lazy"
                      />
                    </div>
                    <span class="font-medium text-slate-700">{{
                      item.name
                    }}</span>
                  </NuxtLink>

                  <button
                    v-if="item.children?.length"
                    @click="handleClick(item, index)"
                    class="p-4 hover:bg-slate-200 transition-colors"
                  >
                    <UIcon
                      name="i-heroicons-chevron-right"
                      class="w-5 h-5 text-slate-500"
                    />
                  </button>
                </div>
              </li>
            </ul>
          </div>
        </TransitionGroup>
      </div>
    </UCard>
  </USlideover>
</template>

<script setup>
const props = defineProps({
  menu: {
    type: Array,
    default: () => []
  }
})

const model = defineModel()
const uiStore = useUiStore()
const nestedMenus = ref([props.menu])
const currentLevel = ref(0)
const currentCategory = ref(null)

const closeSlide = () => {
  uiStore.menuSlide = false
  // Menüyü sıfırla
  setTimeout(() => {
    currentLevel.value = 0
    nestedMenus.value = [props.menu]
    currentCategory.value = null
  }, 300)
}

const goBack = () => {
  if (currentLevel.value > 0) {
    currentLevel.value--
    nestedMenus.value.pop()
    currentCategory.value =
      nestedMenus.value[currentLevel.value][0]?.parent || null
  }
}

const handleClick = (item, levelIndex) => {
  if (item.children?.length) {
    currentLevel.value++
    nestedMenus.value.push(item.children)
    currentCategory.value = item
  }
}

// Props değiştiğinde menüyü güncelle
watch(
  () => props.menu,
  (newMenu) => {
    nestedMenus.value = [newMenu]
    currentLevel.value = 0
    currentCategory.value = null
  }
)
</script>
